import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer/";
import AppButton from "../../components/button/";
import AppTextField from "../../components/text-field/";
import { validateEmail } from "../../utils/validation";
import { useNavigate, useParams } from "react-router-dom";

import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";
import { isAllAddressCookiePresent } from "../../utils/helpers";
import { trackEvents } from "../../utils/tracking-events";
import { convertToLowerCase } from "../../utils/utility-functions";
import { ROMANTIC_COMPATIBILITY_ASSESSMENT_ID } from "../../utils/general-config";

const ForgotPassword = ({ forgotPasswordConnect, funnelStep }) => {
  const navigate = useNavigate();
  const { prefillEmail, assessmentId } = funnelStep || {};
  const [formData, setFormData] = useState({
    email: prefillEmail ? prefillEmail : "",
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const assessmentAttemptIdFromQuery = queryParams.get("assessmentAttemptId");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const parentIdFromQuery = queryParams.get("prntid");
  const assessmentMapIdFromQuery = queryParams.get("assessmapid");
  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const [error, setError] = useState({
    emailError: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "email") {
      error = validateEmail(value, t);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();
    const { email } = formData;
    const isEmailError = validateEmail(email.trim(), t);
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, emailError: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }
    if (isEmailError.length > 0) return;
    const params = {
      serviceCode: "",
      email: email,
      tenantId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      locale: currentLocale,
    };
    try {
      const response = await forgotPasswordConnect(params);
      if (response.isMailSent) {
        toast.success(t("account.forgot_password_tostmsg"));
      } else {
        toast.warning(response.message);
      }
    } catch (error) {
      console.error("Error during forgot password request:", error);
      toast.error("Email not found!");
    }
  };

  const { userGUID: oldUserId, assessmentAttemptId } = funnelStep || {};

  useEffect(() => {
    trackEvents("forgotpasswordview", {
      userGuid: oldUserId,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
    });
  }, []);

  const params = new URLSearchParams({
    assessmentAttemptId:
      assessmentAttemptIdFromQuery || assessmentAttemptId || "",
  });

  if (isRomanticCompatibilityTest && parentIdFromQuery) {
    params.set("prntid", parentIdFromQuery);
    if (assessmentMapIdFromQuery) {
      params.set("assessmapid", assessmentMapIdFromQuery);
    }
  }

  return (
    <>
      <Header />
      <div className="p-5 text-center bg-white flex-grow">
        <h1 className="font-bold color-[#444C5E] text-4xl mb-4">
          {t("account.forgot_password_text")}
        </h1>
        <div className="flex justify-center mt-8">
          <form
            id="forgot-password-form"
            className="space-y-2 w-full max-w-xs"
            onSubmit={handleForgotPassword}
          >
            <AppTextField
              id="forgot-password-email-input"
              label={t("account.email_label")}
              name="email"
              onChange={handleInputChange}
              value={formData.email}
              error={error.emailError}
              placeholder={t("account.email_placholder")}
            />

            <div className="text-right text-sm">
              <p>
                <Link
                  id="forgot-password-login-link"
                  to={`${loginPath.next}?${params.toString()}`}
                  className="text-[#805AED] hover:underline"
                >
                  {t("account.member_login")}
                </Link>
              </p>
            </div>

            <AppButton
              id="forgot-password-submit-button"
              type="submit"
              className="bg-[#FE6634] cursor-pointer text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
            >
              {t("account.send_reset_link_cta")}
            </AppButton>
          </form>
        </div>
      </div>

      <Footer className="fixed bottom-0 " />
    </>
  );
};

export default ForgotPassword;
